import React, { useState, useEffect } from 'react';
import { Modal, Input, Select, Upload, Button, message, Form } from 'antd';
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;

const EditPDFModal = ({ show, onClose, onUpdate, pdf, submitting, categories }) => {
  const [editedPDF, setEditedPDF] = useState({
    title: '',
    description: '',
    category: '',
    file: null
  });
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (pdf) {
      setEditedPDF({
        title: pdf.title,
        description: pdf.description,
        category: pdf.category,
        file: null
      });
    }
  }, [pdf]);

  const handleUpload = (file) => {
    // Check if file is PDF
    if (file.type !== 'application/pdf') {
      message.error('Please upload a PDF file only');
      return false;
    }
    
    setFileList([file]);
    setEditedPDF({ ...editedPDF, file: file });
    return false; // Prevent automatic upload
  };

  const handleSubmit = () => {
    if (!editedPDF.title || !editedPDF.description || !editedPDF.category) {
      message.error('Please fill out all required fields');
      return;
    }
    onUpdate(editedPDF);
  };

  const handleClose = () => {
    setFileList([]);
    setEditedPDF({
      title: '',
      description: '',
      category: '',
      file: null
    });
    onClose();
  };

  return (
    <Modal
      title={
        <div>
          <FilePdfOutlined style={{ marginRight: 8 }} />
          Edit PDF Resource
        </div>
      }
      visible={show}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText="Update"
      cancelText="Cancel"
      confirmLoading={submitting}
      width={600}
    >
      <Form layout="vertical">
        <Form.Item label="Title" required>
          <Input
            placeholder="Enter PDF title"
            value={editedPDF.title}
            onChange={(e) => setEditedPDF({ ...editedPDF, title: e.target.value })}
          />
        </Form.Item>

        <Form.Item label="Description" required>
          <TextArea
            placeholder="Enter PDF description"
            value={editedPDF.description}
            onChange={(e) => setEditedPDF({ ...editedPDF, description: e.target.value })}
            rows={4}
          />
        </Form.Item>

        <Form.Item label="Category" required>
          <Select
            placeholder="Select category"
            value={editedPDF.category}
            onChange={(value) => setEditedPDF({ ...editedPDF, category: value })}
          >
            {categories.map(cat => (
              <Option key={cat.value} value={cat.value}>
                {cat.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Replace PDF File (Optional)">
          <div style={{ marginBottom: 8 }}>
            <a href={pdf?.pdfUrl} target="_blank" rel="noopener noreferrer">
              View Current PDF
            </a>
          </div>
          <Upload
            beforeUpload={handleUpload}
            fileList={fileList}
            onRemove={() => {
              setFileList([]);
              setEditedPDF({ ...editedPDF, file: null });
            }}
            accept=".pdf"
          >
            <Button icon={<UploadOutlined />}>Select New PDF File</Button>
          </Upload>
          {fileList.length > 0 && (
            <div style={{ marginTop: 8, color: '#52c41a' }}>
              New file selected. The current PDF will be replaced upon update.
            </div>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditPDFModal; 